import { favoritesRequest } from "@/views/catalog/api";

// Избранное каталога: общее для шапки (кнопка «Избранное» и окно)
// и карточек главной. Данные живут в базе каталога (api_v2/api/favorites).
export const favoritesModule = {
  state: {
    // избранное загружено с сервера хотя бы раз
    loaded: false,
    // сервер ответил, что избранное доступно (есть действующая сессия ЛК)
    available: false,
    ids: [],
    items: [],
    // id позиций, по которым сейчас идёт добавление/удаление
    pending: [],
    // окно «Избранное» открыто
    open: false,
  },
  getters: {
    getFavoritesLoaded(state) {
      return state.loaded;
    },
    getFavoritesAvailable(state) {
      return state.available;
    },
    getFavoriteIds(state) {
      return state.ids;
    },
    getFavorites(state) {
      return state.items;
    },
    getFavoritesCount(state) {
      return state.ids.length;
    },
    getFavoritesOpen(state) {
      return state.open;
    },
    isFavorite: (state) => (id) => state.ids.includes(id),
    isFavoritePending: (state) => (id) => state.pending.includes(id),
  },
  mutations: {
    setFavorites(state, response) {
      state.available = !!response?.status;
      state.ids = response?.status ? response.ids : [];
      state.items = response?.status ? response.data : [];
      state.loaded = true;
    },
    setFavoritePending(state, { id, value }) {
      state.pending = value
        ? [...state.pending, id]
        : state.pending.filter((item) => item !== id);
    },
    setFavoritesOpen(state, value) {
      state.open = value;
    },
    resetFavorites(state) {
      state.loaded = false;
      state.available = false;
      state.ids = [];
      state.items = [];
      state.pending = [];
      state.open = false;
    },
  },
  actions: {
    async loadFavorites({ commit }) {
      try {
        commit("setFavorites", await favoritesRequest("list"));
      } catch (e) {
        commit("setFavorites", null);
      }
    },
    // добавляет или удаляет позицию; возвращает текст ошибки либо null
    async toggleFavorite({ commit, state }, id) {
      if (state.pending.includes(id)) return null;
      commit("setFavoritePending", { id, value: true });
      try {
        const response = await favoritesRequest(
          state.ids.includes(id) ? "remove" : "add",
          id
        );
        if (response?.status) {
          commit("setFavorites", response);
          return null;
        }
        return response?.error || "Не удалось изменить избранное";
      } catch (e) {
        return "Не удалось изменить избранное. Попробуйте позже.";
      } finally {
        commit("setFavoritePending", { id, value: false });
      }
    },
  },
  namespaced: true,
};
